import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  friendsUpdated = new EventEmitter<any>();

  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService
  ) {}

  getMyFriends(limit: number = 0) {
    return this.httpClient.get<any[]>(
      `${environment.serverPath}/profile/get-friends?limit=${limit}`
    );
  }

  getProfile(id: number) {
    return this.httpClient.get<any>(
      `${environment.serverPath}/profile/get/${id}`
    );
  }

  getPost(postId: number) {
    return this.httpClient.get<any>(
      `${environment.serverPath}/posts/get/${postId}`
    );
  }

  getWallItems(profileId: number, page: number, limit: number) {
    return this.httpClient
      .get<{ count: number; items: any[] }>(
        `${environment.serverPath}/profile/wall-items/${profileId}?page=${page}&limit=${limit}`
      )
      .pipe(
        map((x) => {
          x.items.forEach((o) => {
            this.updateCoverImage(o);
            this.updateProfileImage(o);
            if (o.comments && o.comments.length > 0) {
              o.comments.forEach((z) => {
                this.updateCoverImage(z.profile);
                this.updateProfileImage(z.profile);
              });
            }
          });
          return x;
        })
      );
  }

  getUserFriends(profileId: number, limit: number = 0) {
    return this.httpClient.get<any[]>(
      `${environment.serverPath}/profile/get-profile-friends/${profileId}?checkIsFriendWithMe=1&limit=${limit}`
    );
  }

  getFriendRequests() {
    return this.httpClient.get<any[]>(
      `${environment.serverPath}/profile/get-friend-requests`
    );
  }

  acceptFriendRequest(profileId: number) {
    return this.httpClient.post<any[]>(
      `${environment.serverPath}/profile/accept-friend-request`, {"profileId": profileId}
    );
  }

  addFriend(profileId: number) {
    return this.httpClient.post(
      `${environment.serverPath}/profile/add-friend`,
      { profileId }
    );
  }

  checkAreFriends(profileId: number) {
    return this.httpClient.post<boolean>(
      `${environment.serverPath}/profile/check-are-friends`,
      { profileId }
    );
  }

  removeFriend(profileId: number) {
    return this.httpClient.post(
      `${environment.serverPath}/profile/remove-friend`,
      { profileId }
    );
  }

  ignoreFriendRequest(profileId: number) {
    return this.httpClient.post<any[]>(
      `${environment.serverPath}/profile/ignore-friend-request`, {"profileId": profileId}
    );
  }

  updateProfileImage(profile: any) {
    if (!profile.profileImage) {
      profile.profileImage = "/assets/images/profile.jpg";
    } else {
      if (profile.profileImage.indexOf("http") === -1) {
        profile.profileImage = environment.serverPath + profile.profileImage;
      }
    }
  }

  updateCoverImage(profile: any) {
    if (!profile.profileCover) {
      profile.profileCover = "/assets/images/genericCover.jpg";
    } else {
      if (profile.profileCover.indexOf("http") === -1) {
        profile.profileCover = environment.serverPath + profile.profileCover;
      }
    }
  }

  getPostedOn(datetime: string) {
    const momentTIme = moment(datetime);
    const diffInSeconds = moment().diff(momentTIme, "seconds");
    let str = "";
    if (diffInSeconds < 60) {
      str = this.translateService.instant("timelineHourBeforeSeconds", {
        time: diffInSeconds,
      });
    } else if (diffInSeconds >= 60 && diffInSeconds < 3600) {
      str = this.translateService.instant("timelineHourBeforeMinuts", {
        time: Math.floor(moment().diff(momentTIme, "minutes")),
      });
    } else if (diffInSeconds >= 3600 && diffInSeconds < 86400) {
      str = this.translateService.instant("timelineHourBeforeHours", {
        time: Math.floor(moment().diff(momentTIme, "hours")),
      });
    } else if (diffInSeconds >= 86400 && diffInSeconds < 86400 * 10) {
      str = this.translateService.instant("timelineHourBeforeDays", {
        time: Math.floor(moment().diff(momentTIme, "days")),
      });
    } else {
      str = momentTIme.format("DD/MM/YYYY");
    }
    return str;
  }
}
